// extracted by mini-css-extract-plugin
var _1 = "LeaderboardsRankings__avatar--uLrla";
var _2 = "LeaderboardsRankings__borderedRow--z5F9X LeaderboardsRankings__row--tmyQA fontSize__leaderboardsModalRow--uo7Gv";
var _3 = "LeaderboardsRankings__highlightedRow--UwrT7";
var _4 = "LeaderboardsRankings__leftRowContent--WkCDO";
var _5 = "LeaderboardsRankings__loadIcon--C0h9m";
var _6 = "LeaderboardsRankings__main--khpSF";
var _7 = "LeaderboardsRankings__modalAvatarBackdrop--RYDu0 ModalGeneral__backdrop--gxZiG";
var _8 = "LeaderboardsRankings__modalAvatarCloseIcon--dTUOq";
var _9 = "LeaderboardsRankings__modalAvatarImage--ZHyso";
var _a = "LeaderboardsRankings__modalAvatarMain--dEkli";
var _b = "LeaderboardsRankings__modalAvatarUsername--gyxYK fontSize__leaderboardsAvatarModalUsername--WLi5L";
var _c = "LeaderboardsRankings__modalAvatarUsernameBG--YEE8Q";
var _d = "LeaderboardsRankings__modalAvatarUsernameQuad--d9k5V";
var _e = "LeaderboardsRankings__noRowsText--l4KW3 fontSize__leaderboardsModalRow--uo7Gv";
var _f = "LeaderboardsRankings__nonhighlightedRow--zfsvg";
var _10 = "LeaderboardsRankings__rankNumber--y3g4l";
var _11 = "LeaderboardsRankings__rightRowContent--ALYun";
var _12 = "LeaderboardsRankings__row--tmyQA fontSize__leaderboardsModalRow--uo7Gv";
var _13 = "LeaderboardsRankings__rowsContainer--R8Si7";
var _14 = "LeaderboardsRankings__trophyIcon--NRJbj";
var _15 = "LeaderboardsRankings__winnerIcon--Z4PGT";
var _16 = "LeaderboardsRankings__xpIcon--hmV5J";
export { _1 as "avatar", _2 as "borderedRow", _3 as "highlightedRow", _4 as "leftRowContent", _5 as "loadIcon", _6 as "main", _7 as "modalAvatarBackdrop", _8 as "modalAvatarCloseIcon", _9 as "modalAvatarImage", _a as "modalAvatarMain", _b as "modalAvatarUsername", _c as "modalAvatarUsernameBG", _d as "modalAvatarUsernameQuad", _e as "noRowsText", _f as "nonhighlightedRow", _10 as "rankNumber", _11 as "rightRowContent", _12 as "row", _13 as "rowsContainer", _14 as "trophyIcon", _15 as "winnerIcon", _16 as "xpIcon" }
